const sections = document.querySelectorAll('section');
const navLinks = document.querySelectorAll('header nav a');

window.addEventListener('scroll', () => {
  const top = window.scrollY;

  if (top === 0) {
    navLinks.forEach(link => link.classList.remove('active'));
    if (navLinks[0]) {
      navLinks[0].classList.add('active');
    }
  } else {
    sections.forEach(sec => {
      const offset = sec.offsetTop - 150;
      const height = sec.offsetHeight;
      const id = sec.getAttribute('id');

      if (top >= offset && top < offset + height) {
        navLinks.forEach(link => link.classList.remove('active'));

        const targetLink = document.querySelector(
          `header nav a[href*="${id}"]`
        );
        if (targetLink) {
          targetLink.classList.add('active');
        }
      }
    });
  }
});

const menuBlock = document.querySelector('.header__blocks');

function toggleMenuOnScroll() {
  const pos2 = document.documentElement.scrollTop;

  if (pos2 > 50) {
    menuBlock.classList.add('active', 'open');
  } else {
    menuBlock.classList.remove('active', 'open');
  }
}

const scrollProgress = document.getElementById('progress');

function calcScrollValue() {
  const pos = document.documentElement.scrollTop;
  const calcHeight =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;

  const scrollValue = Math.round((pos * 100) / calcHeight);

  if (pos > 100) {
    scrollProgress.style.display = 'grid';
  } else {
    scrollProgress.style.display = 'none';
  }

  scrollProgress.style.background = `conic-gradient(var(--red-color) ${scrollValue}%, transparent ${scrollValue}%)`;
}

scrollProgress.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.addEventListener('DOMContentLoaded', () => {
  try {
    const animatedElements = document.querySelectorAll('[data-animate]');

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.target instanceof Element) {
            const animation = entry.target.dataset.animate;
            entry.target.classList.add(
              'animate__animated',
              `animate__${animation}`
            );
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    animatedElements.forEach(el => {
      observer.observe(el);
    });
  } catch (error) {
    console.log(`Ошибка с анимациями: ${error}`);
  }
});

window.addEventListener('scroll', toggleMenuOnScroll);
window.addEventListener('scroll', calcScrollValue);
window.addEventListener('load', calcScrollValue);
